import { Phone, Mail, MessageSquare, Smile, CheckSquare, AudioWaveform, ExternalLink, Clock, PhoneOff, Flag, MessageCircle, Paperclip, Link } from 'lucide-react';

/**
 * Activity List widget constants.
 * Activity types map to Figma IconHighlight variants.
 * bgColor / iconColor are Tailwind color tokens (bg-X and text-X).
 */
export const ACTIVITY_TYPE_CONFIG = Object.freeze({
  call: {
    icon: Phone,
    bgColor: 'bg-blue-100 dark:bg-blue-950/50',
    iconColor: 'text-blue-600 dark:text-blue-400',
  },
  email: {
    icon: Mail,
    bgColor: 'bg-sky-100 dark:bg-sky-950/50',
    iconColor: 'text-sky-600 dark:text-sky-400',
  },
  sms: {
    icon: MessageSquare,
    bgColor: 'bg-amber-100 dark:bg-amber-950/50',
    iconColor: 'text-amber-600 dark:text-amber-400',
  },
});

/** Alert types for critical states (WID-04) */
export const ALERT_TYPES = Object.freeze({
  NEEDS_ATTENTION: 'needs_attention',
  EXPIRED: 'expired',
});

/** Width threshold: layout w <= this shows compressed variant */
export const COMPRESSED_LAYOUT_W_THRESHOLD = 4;

export const ACTIVITY_CARD_MAX_CHARACTERS = 80;

/** Maps metadata keys to Lucide icon components */
export const METADATA_ICONS = Object.freeze({
  sentiment: Smile,
  assignedTasks: CheckSquare,
  hasRecording: AudioWaveform,
  hasExternalLink: ExternalLink,
  duration: Clock,
  direction: PhoneOff,
  flagged: Flag,
  comments: MessageCircle,
  attachments: Paperclip,
  link: Link,
});

export const METADATA_BAR_CONFIG = Object.freeze({
  call: ['userId', 'sentiment', 'assignedTasks', 'hasRecording', 'hasExternalLink', 'duration', 'direction', 'flagged'],
  email: ['userId', 'commentsCount', 'attachmentsCount', 'assignedTasks', 'hasExternalLink', 'flagged'],
  sms: ['userId', 'commentsCount', 'attachmentsCount', 'assignedTasks', 'hasExternalLink', 'linkCount', 'flagged'],
});

export { ACTIVITY_STATE_COPY } from '../../../../constants';
